import { render } from "./OrgEmailBranding.vue?vue&type=template&id=f8a80adc&scoped=true"
import script from "./OrgEmailBranding.vue?vue&type=script&lang=js"
export * from "./OrgEmailBranding.vue?vue&type=script&lang=js"

import "./OrgEmailBranding.vue?vue&type=style&index=0&id=f8a80adc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a80adc"]])

export default __exports__